import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div>
      <div class="p-4 bg-[#f2ffe2] rounded-lg shadow-xl md:px-6 md:py-8 dark:bg-gray-900 px-28 mt-5">
        <div class="flex items-center justify-between sm:flex-wrap sm:justify-center">
          <div>
            <a href="/" class="flex items-center mb-4 sm:mb-0">
              <img
                src="/logo.png"
                class="h-auto w-32 mr-3"
                alt="Flowbite Logo"
              />
            </a>
          </div>
          <div>
            <ul class="flex flex-wrap items-center justify-center mb-6  sm:mt-3 text-md text-gray-700 sm:mb-0 dark:text-gray-400">
              <li className="mr-5 sm:mr-2">
                <Link
                  to="/Article"
                  class=" cursor-pointermr-4 hover:underline md:mr-4"
                >
                  Articles
                </Link>
              </li>
              <li className="mr-5 sm:mr-2">
                <Link
                  to="/About"
                  class=" cursor-pointermr-4 hover:underline md:mr-4"
                >
                  About
                </Link>
              </li>
              <li className="mr-5 sm:mr-2">
                <Link
                  to="/PrivacyPolicy"
                  class=" cursor-pointermr-4 hover:underline md:mr-4"
                >
                  Privacy&Policy
                </Link>
              </li>
              <li className="mr-5 sm:mr-2">
                <Link
                  to="/Terms"
                  class=" cursor-pointermr-4 hover:underline md:mr-4"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span class="block text-sm text-gray-500 text-center dark:text-gray-400">
          © 3{" "}
          <a href="/" class="hover:underline">
            Agriculture
          </a>
          . All Rights Reserved.
        </span>
      </div>
    </div>
  );
}

export default Footer;
